import {ReactElement} from "react";

export interface ReachState {
    editingReachElements: Array<ReachElement>;
    generalValidationErrors: string[];
}

export interface Svhc {
    id: number;
    name: string;
    ec: string;
    cas: string;
    indexNumber?: string;
    specifiaction?: string; // FIXME spellings on server-side
    sortValue: number;
    inclusionDate: number;
    threshold: number;
    messageD: string;
    messageE: string;
    required?: boolean;
}

export interface ReachElementDbModel {
    id?: number;
    substanceId: number;
    product?: number;
    productPackage?: number;
    coveringBox?: number;
    parts?: ReachPart[];

    [key: string]: undefined | number | string | ReachPart[] | string[];
}

export interface ReachElement extends ReachElementDbModel {
    productValidation?: string[];
    productPackageValidation?: string[];
    coveringBoxValidation?: string[];
    validation?: string[];

    [key: string]: undefined | number | string | ReachPart[] | string[];
}

export interface ReachPart {
    id?: number;
    descriptionD?: string;
    descriptionE?: string;
    custom: boolean;
    active: boolean;
}

export interface ReachElementsAndErrors {
    elements: Array<ReachElement>,
    errors: string[]
}

export const SET_EDITING_REACH_ELEMENTS = "SET_EDITING_REACH_ELEMENTS";
export const SET_GENERAL_VALIDATION_ERRORS = "SET_GENERAL_VALIDATION_ERRORS";
export const SET_REACH_ELEMENTS_AND_ERRORS = "SET_REACH_ELEMENTS_AND_ERRORS";

interface setEditingReachElementsAction {
    type: typeof SET_EDITING_REACH_ELEMENTS;
    payload: Array<ReachElement>;
}

interface setGeneralValidationErrorsAction {
    type: typeof SET_GENERAL_VALIDATION_ERRORS;
    payload: string[];
}

interface setReachElementsErrorsAction {
    type: typeof SET_REACH_ELEMENTS_AND_ERRORS;
    payload: ReachElementsAndErrors;
}

export type ReachTypes =
    setEditingReachElementsAction
    | setGeneralValidationErrorsAction
    | setReachElementsErrorsAction;